<template>
  <div class="forEmployers--logo">
    <div class="forEmployers--logo__container">
      <img
        class="forEmployers--logo__logo"
        src="/images/wellbeing-sale/forEmployers/logo.png"
        alt="logo"
      >

      <img
        class="forEmployers--logo__separator"
        src="/images/wellbeing-sale/forEmployers/separator.svg"
        alt="logo"
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
.forEmployers--logo {
  max-width: 129.2rem;
  width: 100%;
  margin: 2.4rem auto 4rem auto;

  &__container {
    position: relative;
    width: 100%;
  }

  &__separator {
    position: absolute;
    bottom: -2.7rem;
    left: -65rem;
    z-index: -1;
    max-inline-size: unset;
  }
}

@include atM {
  .forEmployers--logo {
    display: flex;
    justify-content: center;
    margin: -2.4rem auto 5.6rem auto;

    &__container {
      width: fit-content;
      margin-left: 29.6rem;
    }
  }
}
</style>
